import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Icon, Button } from 'semantic-ui-react';
import API from 'utils/api';
import Header from 'components/Header';
import Message from 'components/Message';
import MenuProductsList from './ui/MenuProductsList';

class MenuProductsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: [],
      loading: true,
    };
  }
  
  componentDidMount() {
    this.fetchMenuData();
  }
  
  fetchMenuData = () => {
    this.setState({ loading: true });
    
    API.getProducts()
      .then((response) => {
        this.setState({
          menu: response.data,
          loading: false
        });
      })
      .catch((error) => {
        console.error('Error fetching menu data:', error);
        this.setState({ loading: false });
      });
  }
  
  render() {
    return (
      <div>
        <Header 
          text="Tu Menú"
        />

        { this.state.loading ? (
          <div style={{ textAlign: 'center', padding: '2em' }}>
            <Icon loading name='spinner' size='large' />
            <p style={{ marginTop: '1em', color: '#666', fontSize: '1.2em' }}>Cargando menú...</p>
          </div>
        ) : this.state.menu.length === 0 ? (
          <Message>
            <p style={{ fontSize: '1.3em', lineHeight: '1.4' }}>
              Aún no tienes ninguna categoría en tu menú. Da click en el botón de abajo para crear nuevas categorías y después agregar productos.
            </p>
          </Message>
        ) : (
          <div style={{ marginTop: '1.5em' }}>
            <MenuProductsList menu={this.state.menu} history={this.props.history} onRefresh={this.fetchMenuData} />
          </div>
        )}
        
        <Button 
          as={Link} 
          to="/menu/categories/new"
          primary
          fluid
          size="large"
          style={{ 
            marginTop: '32px',
            marginBottom: '24px',
            height: '54px',
            borderRadius: '8px',
            fontSize: '1.2em',
            fontWeight: 'bold',
            boxShadow: 'none',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          agregar nueva categoría
        </Button>
      </div>
    )
  }
}
export default withRouter(MenuProductsPage);